import { IFetchTariffParams } from '@/services';
import { TariffContext, ITariffActions } from './actions.types';
import { ITariffData } from '@/models';

export const actions: ITariffActions = {
  fetchTariffRates(
    context: TariffContext,
    payload?: IFetchTariffParams
  ): Promise<void> {
    const promise = this.$services.tariff.fetchTariffRates(payload);
    context.commit('SET_LAST_PROMISE', promise);

    return promise.then((tariffs: ITariffData[]) => {
      if (promise == context.state.lastPromise) {
        context.commit('SET_TARIFFS', tariffs);
      }
      context.commit('SET_LAST_PROMISE', null);
    });
  },

  fetchTariffRate(context: TariffContext, payload: number): Promise<void> {
    return this.$services.tariff
      .fetchTariffRate(payload)
      .then((tariff: ITariffData) => {
        context.commit('UPSERT_TARIFF', tariff);
      });
  },

  createTariffRate(
    context: TariffContext,
    payload: ITariffData
  ): Promise<number> {
    return this.$services.tariff
      .createTariffRate(payload)
      .then((tariff: ITariffData) => {
        context.commit('UPSERT_TARIFF', tariff);

        return tariff.id!;
      });
  },

  updateTariffRate(
    context: TariffContext,
    payload: ITariffData
  ): Promise<void> {
    return this.$services.tariff
      .updateTariffRate(payload)
      .then((tariff: ITariffData) => {
        context.commit('UPSERT_TARIFF', tariff);
      });
  },

  deleteTariffRate(context: TariffContext, payload: number): Promise<void> {
    return this.$services.tariff.deleteTariffRate(payload).then(() => {
      context.commit('REMOVE_TARIFF', payload);
    });
  }
};
